import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { affect_color_filter } from '../../lib/ep.js';
import Konva from 'konva';
import { Stage, Layer } from 'react-konva';

const white_color = '#FFFFFF';
const gray_color = '#CCCCCC';

const ConfettiCanvas = forwardRef((props, ref) => {
	let refs = useRef([]);

	const is_debug_mode = (props.is_debug_mode != undefined) ? props.is_debug_mode : false;
	const canvas_size_w = props.canvas_size_w;
	const canvas_size_h = props.canvas_size_h;
	const y_displacement = props.y_displacement;

	const main_color = props.main_color != undefined ? props.main_color : '#2951CC';
	const confetti_colors = [
		white_color,
		gray_color,
		affect_color_filter(-0.7, main_color),
		affect_color_filter(-0.5, main_color),
		affect_color_filter(-0.3, main_color),
		main_color,
		affect_color_filter(0.3, main_color),
		affect_color_filter(0.5, main_color),
		affect_color_filter(0.7, main_color),
	];

	const max_confetti_particles = 150;
	const min_X_pos = canvas_size_w / 2;
	const ini_Y_pos = canvas_size_h / 2;
	const end_Y_pos = canvas_size_h;
	const max_X_pos = canvas_size_w;
	const max_Y_pos = 28;

	const steps = 50;
	let anim;
	let pos = 0;

	const calcParabolicPath = (direction) => {
		const scale_x = direction * Math.random();
		const scale_y = Math.random();

		let p = `M${canvas_size_w / 2},${canvas_size_h / 2}`;
		p += `c0,0,${80 * scale_x}-${canvas_size_h * scale_y / 2},${200 * scale_x}-${canvas_size_h * scale_y / 2}`
		p += `s${200 * scale_x},${canvas_size_h * 0.7 * scale_y},${200 * scale_x},${end_Y_pos}`

		return p;
	};

	const confettiParticle = (i) => {
		const direction = (i % 2 === 0) ? 1 : -1;

		const end_X_pos = max_X_pos + 50 * Math.random();

		const particle_path = new Konva.Path({
			data:calcParabolicPath(direction),
			id:`path_${i}`,
			stroke:'rgba(' + ((direction < 0) ? 0 : 255) + ', 0, 0, ' + ((is_debug_mode) ? 0.2 : 0) + ')',
			strokeWidth:1,
		});
		refs.current[`whole_confetti_ref`].add(particle_path);

		const particle_width  = Math.floor(Math.random() * 6) + 4;
		const particle_height = Math.floor(Math.random() * 8) + 6;

		const particle = new Konva.Rect({
			width:particle_width,
			height:particle_height,
			fill:confetti_colors[Math.floor(Math.random() * confetti_colors.length) + 1],
			offsetX:particle_width / 2,
			offsetY:particle_height / 2,
			rotation:Math.round(360 * Math.random()),
			id:`particle_${i}`,
			x:min_X_pos,
			y:ini_Y_pos,
		});

		refs.current[`whole_confetti_ref`].add(particle);
	};

	const explodeConfetti = () => {
		anim = new Konva.Animation((frame) => {
			if(pos < steps + 3) {
				pos = pos + 1;	// variar aquest "1" perquè faci disminució parabòlica

				for(var i = 0; i < max_confetti_particles; i++) {
					const direction = (i % 2 === 0) ? 1 : -1;
					const path = refs.current[`whole_confetti_ref`].findOne(`#path_${i}`);
					const pt = path.getPointAtLength(pos * path.getLength() / steps);
					refs.current[`whole_confetti_ref`].findOne(`#particle_${i}`).position({x:pt.x, y:pt.y}).rotate(2 * direction);
				}
			} else {
				pos = 0;
				destroyElements();
				return false;
			}
		}, refs.current[`whole_confetti_ref`]);

		anim.start();
	};

	const generateConfetti = () => {
		for(var i = 0; i < max_confetti_particles; i++) confettiParticle(i);
		refs.current[`whole_confetti_ref`].draw();
	};

	const destroyElements = () => {
		if(anim != undefined && anim.isRunning()) anim.stop();
		refs.current[`whole_confetti_ref`].destroyChildren();
	};

	useImperativeHandle(ref, () => ({
		play_animation() {
			generateConfetti();
			explodeConfetti();
		},

		init_animation() {
			generateConfetti();
		},

		destroy_animation() {
			destroyElements();
		}
	}));

	useEffect(() => {
		return () => {
			destroyElements();
		}
	}, []);

	return (
		<Stage class="confetti_stage" width={canvas_size_w} height={canvas_size_h} y={y_displacement}>
			<Layer ref={(node) => { refs.current['whole_confetti_ref'] = node; }} />
		</Stage>
	);
});

export default ConfettiCanvas;